export const logoSidebarMinimized = ['40 40', `
  	<title>sidebar minimized logo</title>
  	<g>
		<path fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" d="M20,19.042h17.735c0-9.795-7.94-17.735-17.735-17.735   s-17.735,7.94-17.735,17.735s7.94,17.735,17.735,17.735V19.042z"/>
		<path fill-rule="evenodd" clip-rule="evenodd" fill="#BE1E2D" d="M22.118,20.688v17.735c9.795,0,17.735-7.94,17.735-17.735   H196.118z"/>
	</g>
`]